import { Card } from "@/components/ui/card";
import { GraduationCap, Briefcase, Building2, Cpu, Users, Target, Landmark } from "lucide-react";

const CSROverview = () => {
  const coverageItems = [
    { text: "Education & skill development for care-leavers", icon: GraduationCap },
    { text: "Employability & livelihood transition programs", icon: Briefcase },
    { text: "State-linked aftercare initiatives", icon: Building2 },
    { text: "Technology-enabled care-leaver support systems", icon: Cpu }
  ];

  const audienceItems = [
    { text: "CSR Heads & CSR Committees", icon: Users },
    { text: "Sustainability / ESG Leaders", icon: Target },
    { text: "Corporate Foundations & Trusts", icon: Landmark }
  ];

  return (
    <section id="programs" className="py-12 md:py-16 bg-[#F8F9F7]" data-testid="csr-overview-section">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-5xl mx-auto">
          
          {/* Section Title */}
          <div className="text-center mb-8">
            <h2 className="font-display text-xl md:text-2xl font-bold text-[#4A4A4A]">
              CSR Partnership Overview
            </h2>
          </div>

          {/* Two Column Layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            
            {/* LEFT BLOCK - What This CSR Partnership Covers */}
            <Card className="p-6 border border-[#E5E7EB] bg-white shadow-sm" data-testid="coverage-block">
              <h3 className="font-display text-lg font-bold text-[#4A4A4A] mb-4">
                What This CSR Partnership Covers
              </h3>
              
              <ul className="space-y-3 mb-4">
                {coverageItems.map((item, index) => (
                  <li 
                    key={index} 
                    className="flex items-center gap-3"
                    data-testid={`coverage-item-${index}`}
                  >
                    <div className="w-8 h-8 rounded-lg bg-[#1F7A5A]/10 flex items-center justify-center flex-shrink-0">
                      <item.icon className="w-4 h-4 text-[#1F7A5A]" />
                    </div>
                    <span className="text-sm text-[#4A4A4A]">{item.text}</span>
                  </li>
                ))}
              </ul>
              
              <p className="text-xs text-[#9CA3AF] pt-3 border-t border-[#E5E7EB]">
                All programs are modular, budget-defined, and CSR-compliant.
              </p>
            </Card>

            {/* RIGHT BLOCK - Who This Is For */}
            <Card className="p-6 border border-[#E5E7EB] bg-white shadow-sm" data-testid="audience-block">
              <h3 className="font-display text-lg font-bold text-[#4A4A4A] mb-4">
                Who This Is For
              </h3>
              
              <ul className="space-y-3 mb-4">
                {audienceItems.map((item, index) => (
                  <li 
                    key={index} 
                    className="flex items-center gap-3"
                    data-testid={`audience-item-${index}`}
                  >
                    <div className="w-8 h-8 rounded-lg bg-[#4FB6A6]/10 flex items-center justify-center flex-shrink-0">
                      <item.icon className="w-4 h-4 text-[#4FB6A6]" />
                    </div>
                    <span className="text-sm text-[#4A4A4A]">{item.text}</span>
                  </li>
                ))}
              </ul>
              
              <p className="text-xs text-[#9CA3AF] pt-3 border-t border-[#E5E7EB]">
                This page is designed for institutional and CSR decision-makers.
              </p>
            </Card>

          </div>
        </div>
      </div>
    </section>
  );
};

export default CSROverview;
